











import { Component, Vue, Prop } from 'vue-property-decorator';
import dataObj from '@/core/cosUploadFile.js';

/* 文件信息 */
interface FileInfo {
  name: string,
  type: string,
  format: string,
  url?: string,
  file: File,
  size: number
}

@Component
export default class ChooseFile extends Vue {
  //接受文件类型
  @Prop({
    type: String,
    default: 'accept'
  })
  public accept!: string;

  //是否压缩
  @Prop({
    type: Boolean,
    default: true
  })
  public compress!: boolean;

  //记录URL
  private url?: string;

  //图像文件转换URL
  public imageFileToUrl(file: File): string | undefined {
    if (/^image/.test(file.type)) {
      return (window.URL || window.webkitURL || window).createObjectURL(file);
    }
    return undefined;
  }

  //转换图片信息
  private toFileInfo(file: File): FileInfo | undefined {
    if (file instanceof File) {
      const [ type, format ] = file.type.split('/');

      if (this.url) {
        (window.URL || window.webkitURL || window).revokeObjectURL(this.url);
      }
      this.url = this.imageFileToUrl(file);

      return {
        type,
        format,
        file: file,
        name: file.name,
        size: file.size,
        url: this.url
      };
    }
  }



  //选择文件
  private onFileChange(event: any) {
    const file = event.target.files[0];

      let fileInfo = this.toFileInfo(file);
      if (fileInfo) {
        dataObj.putFile(fileInfo.file).then((res: any) => {
          console.log( res , '已上传文件222')
          this.$emit('change', res );
        });
      }
    // }
    event.target.value = '';
  }
}
